<template>
  <el-dialog
    :title="$t('sections.login.userProfileModal.title')"
    :visible.sync="showModal"
    width="40%"
    :key="`backoffice-modal-${key}`"
  >
    <div class="row">
      <div class="d-flex flex-column align-items-end col-auto">
        <HorizontalDetailTitle
          :label="$t('sections.login.userProfileModal.profile')"
          :valid="validProfile"
        />
      </div>
      <div class="d-flex flex-column col-auto flex-fill">
        <HorizontalDetailInput
          type="dropdown"
          name="profile"
          :options="profileOptions"
          :field="profile"
          edit
          :valid="validProfile"
          :errorLabel="$t('components.horizontalInput.missingField')"
          @input="(e) => { profile = e }"
        />
      </div>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="handleDialogClose" class="outline-button">
        {{ $t("sections.login.userProfileModal.cancelButton") }}
      </el-button>
      <el-button
        type="primary"
        @click="$emit('continue', profile)"
        :disabled="!validFields"
      >
        {{ $t("sections.login.userProfileModal.continueButton") }}
      </el-button>
    </span>
  </el-dialog>
</template>
<script>
import { mapGetters } from 'vuex';
import HorizontalDetailTitle from '@/components/ui/HorizontalDetailTitle.vue';
import HorizontalDetailInput from '@/components/ui/HorizontalDetailInput.vue';

export default {
  name: 'UserProfileModal',
  components: {
    HorizontalDetailTitle,
    HorizontalDetailInput,
  },
  props: {
    showModal: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      key: 0,
      profile: undefined,
    };
  },
  computed: {
    ...mapGetters(['getUser']),
    validProfile() {
      return (
        this.profile === undefined
        || this.profile.length > 0
      );
    },
    validFields() {
      return (
        this.profile
        && this.validProfile
      );
    },
    profileOptions() {
      if (!this.getUser) {
        return [];
      }
      return this.getUser.roles.map((role) => role.profile);
    },
  },
  methods: {
    onAdd() {
      this.$emit('add', this.profile);
      this.profile = undefined;
    },
    handleDialogClose() {
      this.profile = undefined;
      this.$emit('close');
      this.key += 1;
    },
  },
};
</script>
<style lang="scss" scoped>
::v-deep .el-dialog__headerbtn {
  display: none;
}
</style>
